import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import dynamic from "next/dynamic";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { getHome } from "services/home.api";
import { getNewsList } from "services/news.api";
var Seo = dynamic(function() {
    return import("components/Seo");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/Seo")
            ];
        }
    }
});
var PageLoader = dynamic(function() {
    return import("components/PageLoader");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PageLoader")
            ];
        }
    }
});
var SearchResult = dynamic(function() {
    return import("components/Search/SearchResult");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/Search/SearchResult")
            ];
        }
    }
});
var GlanceSection = dynamic(function() {
    return import("components/PagesComponents/Home/GlanceSection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/GlanceSection")
            ];
        }
    }
});
var SustainabilitySection = dynamic(function() {
    return import("components/PagesComponents/Home/SustainabilitySection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/SustainabilitySection")
            ];
        }
    }
});
var AboutSection = dynamic(function() {
    return import("components/PagesComponents/Home/AboutSection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/AboutSection")
            ];
        }
    }
});
var NewsSection = dynamic(function() {
    return import("components/PagesComponents/Home/NewsSection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/NewsSection")
            ];
        }
    }
});
var HeaderSection = dynamic(function() {
    return import("components/PagesComponents/Home/HeaderSection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/HeaderSection")
            ];
        }
    }
});
var ProductSection = dynamic(function() {
    return import("components/PagesComponents/Home/ProductSection");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("components/PagesComponents/Home/ProductSection")
            ];
        }
    }
});
function Home() {
    var ref = useRouter(), locale = ref.locale, query = ref.query;
    var ref1 = useQuery({
        queryKey: [
            "home",
            locale
        ],
        queryFn: function() {
            return getHome(locale);
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchInterval: false,
        refetchOnWindowFocus: false
    }), data = ref1.data, isError = ref1.isError, isRefetching = ref1.isRefetching, isLoading = ref1.isLoading;
    var ref2 = useQuery({
        queryKey: [
            "news-section",
            locale
        ],
        queryFn: function() {
            return getNewsList(locale, {
                pagination: {
                    page: 1,
                    pageSize: 9
                }
            });
        },
        staleTime: 0
    }), news = ref2.data, isErrorNews = ref2.isError, isNewsLoading = ref2.isLoading;
    if (!!(query === null || query === void 0 ? void 0 : query.search)) return /*#__PURE__*/ _jsx(SearchResult, {});
    return /*#__PURE__*/ _jsx("main", {
        children: isLoading || isRefetching ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(PageLoader, {})
        }) : isError || !(data === null || data === void 0 ? void 0 : data.data) ? "error . . . " : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Seo, {
                    seo: data === null || data === void 0 ? void 0 : data.data.attributes.seo
                }),
                /*#__PURE__*/ _jsx(HeaderSection, {
                    header: data === null || data === void 0 ? void 0 : data.data.attributes.header
                }),
                /*#__PURE__*/ _jsx(ProductSection, {}),
                /*#__PURE__*/ _jsx(NewsSection, {
                    news: news,
                    isLoading: isNewsLoading,
                    isErrorNews: isErrorNews
                }),
                /*#__PURE__*/ _jsx(AboutSection, {
                    about: data === null || data === void 0 ? void 0 : data.data.attributes.about
                }),
                /*#__PURE__*/ _jsx(SustainabilitySection, {
                    sustain: data === null || data === void 0 ? void 0 : data.data.attributes.sustainability
                }),
                /*#__PURE__*/ _jsx(GlanceSection, {
                    glance: data === null || data === void 0 ? void 0 : data.data.attributes.glance
                })
            ]
        })
    });
}
export var __N_SSP = true;
export default _withSuperJSONPage(Home);
